import { combineReducers } from 'redux';

import {
  IComplianceState,
  complianceInitialState,
  complianceReducer,
} from './Compliance';
import {
  ILoanBookState,
  loanBookInitialState,
  loanBookReducer,
} from './LoanBook';
import {
  IPreferenceState,
  preferenceInitialState,
  preferenceReducer,
} from './Preferences';

export interface ISettingsState {
  compliance: IComplianceState;
  preference: IPreferenceState;
  loanBook: ILoanBookState;
}

export const settingsInitialState = {
  compliance: complianceInitialState,
  preference: preferenceInitialState,
  loanBook: loanBookInitialState,
};

export const settingsReducer = combineReducers({
  compliance: complianceReducer,
  preference: preferenceReducer,
  loanBook: loanBookReducer,
});
